import "./index.scss";
import { Badge } from "@wise-emotions/react-badge";
import React from "react";

export type Card9Props = {
  imageSrc: string;
  label: string;
  /**
   * If the service is a promo the relative badge appears
   * @default false
   */
  isPromo?: boolean;
  /**
   * Used for e2e and unit test
   */
  dataTestId?: string;
};

const Card9 = ({
  imageSrc,
  label,
  isPromo = false,
  dataTestId,
}: Card9Props) => {
  return (
    <div data-testid={dataTestId} className="card9">
      {isPromo && (
        <div className="card9__badge">
          <Badge
            variant="iconAndLabel"
            theme="promo"
            contrast="high-contrast"
            label="Promo"
          />
        </div>
      )}
      <img src={imageSrc} alt={label} className="card9__image" />
      <span className="card9__label">{label}</span>
    </div>
  );
};

export default Card9;
